import { Instance, types } from 'mobx-state-tree'

export enum Limit {
  JM = 'JioMoney', // "closedexitlimit"
  CCDC = 'CreditDebitCard', //  Debit "openexitlimit"
}

const Limits = types.model('Limits', {
  type: types.enumeration(Object.values(Limit)),
  maxLimit: types.string,
})

const limitsData0 = Limits.create({
  type: Limit.JM,
  maxLimit: '10000',
})

const limitsData1 = Limits.create({
  type: Limit.CCDC,
  maxLimit: '20000',
})

export { Limits, limitsData0, limitsData1 }
export type LimitsV2 = Instance<typeof Limits>
